import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { services } from '../data/mock';

const Services = () => {
  return (
    <section id="services" className="section bg-[#0d1f33]">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="caption text-[#F7931E] mb-4 block">What We Do</span>
          <h2 className="heading-2 text-white mb-4">Our Services</h2>
          <p className="body-large max-w-2xl mx-auto">
            From elegant bathroom renovations to stunning kitchen backsplashes, 
            we handle all aspects of interior tile work with precision and care.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {services.map((service, index) => (
            <div 
              key={service.id} 
              className="service-card group cursor-pointer rounded-lg"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden rounded-t-lg">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0d1f33] to-transparent opacity-60" />
                
                {/* Hover Icon */}
                <div className="absolute top-4 right-4 w-10 h-10 bg-[#F7931E] rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <ArrowUpRight size={20} className="text-[#0d1f33]" />
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="heading-3 text-white mb-3 group-hover:text-[#F7931E] transition-colors">
                  {service.title}
                </h3>
                <p className="text-[#8fa3b8] leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
